import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core';
import { fade, makeStyles } from '@material-ui/core/styles';
import Intestazione from './Intestazione';
import useStili from './stili';

const useStyles = makeStyles((theme) => ({
  areaRilascio: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(5, 3),
    border: `2px dashed ${theme.palette.grey[400]}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.neutral.light,
  },
  areaRilascioAttiva: {
    borderColor: theme.palette.primary.main,
    backgroundColor: fade(theme.palette.primary.main, 0.06),
  },
  invito: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  bottone: {
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  motivoScarto: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1.5),
  },
}));

/** The first step: the operator drops the Export JSON or picks it from disk. */
const SceltaFile = ({ motivoScarto, onScegli, onAnnulla }) => {
  const stili = useStili();
  const classes = useStyles();
  const input = useRef(null);
  const [trascinamento, setTrascinamento] = useState(false);

  const onDragOver = (event) => {
    event.preventDefault();
    setTrascinamento(true);
  };
  // Moving over a child of the area fires a leave on the area itself.
  const onDragLeave = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setTrascinamento(false);
    }
  };
  const onDrop = (event) => {
    event.preventDefault();
    setTrascinamento(false);
    onScegli(Array.from(event.dataTransfer.files));
  };
  const onChange = (event) => {
    const files = Array.from(event.target.files);
    // Emptied so that picking the same file again, after a refusal, still
    // fires a change.
    event.target.value = '';
    if (files.length > 0) onScegli(files);
  };

  return (
    <>
      <DialogContent className={stili.content}>
        <Intestazione
          titolo="Importa la configurazione"
          testo="Carica l'Export JSON prodotto da HACCP Agent al termine dell'intervista."
        />
        <div
          className={
            trascinamento
              ? `${classes.areaRilascio} ${classes.areaRilascioAttiva}`
              : classes.areaRilascio
          }
          onDragOver={onDragOver}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
          data-testid="area-rilascio-json"
        >
          <Typography className={classes.invito}>
            {trascinamento
              ? 'Rilascia il file per verificarlo'
              : 'Trascina qui il file'}
          </Typography>
          <Typography variant="body2" className={stili.testo}>
            oppure
          </Typography>
          <Button
            variant="outlined"
            className={`${stili.secondario} ${classes.bottone}`}
            onClick={() => input.current.click()}
          >
            Scegli dal computer
          </Button>
          <input
            ref={input}
            type="file"
            accept=".json,application/json"
            hidden
            onChange={onChange}
            data-testid="input-file-json"
          />
        </div>
        {motivoScarto && (
          <Typography
            variant="body2"
            role="alert"
            className={classes.motivoScarto}
          >
            {motivoScarto}
          </Typography>
        )}
        <Typography variant="body2" className={stili.nota}>
          Un solo file .json. Il contenuto viene verificato prima di toccare la
          Gestione Operativa: finché la verifica non passa, nulla viene scritto.
        </Typography>
      </DialogContent>
      <DialogActions disableSpacing className={stili.actions}>
        <Button
          variant="outlined"
          className={stili.secondario}
          onClick={onAnnulla}
        >
          Annulla
        </Button>
      </DialogActions>
    </>
  );
};

SceltaFile.propTypes = {
  motivoScarto: PropTypes.string,
  onScegli: PropTypes.func.isRequired,
  onAnnulla: PropTypes.func.isRequired,
};

export default SceltaFile;
